<script setup lang="ts">
type Props = {
    url: string
    platform: string
    icon: string
}

const { url, platform, icon } = defineProps<Props>()
</script>

<template>
    <a
        :href="url"
        target="_blank"
        rel="noreferrer"
        class="py-2 px-5 rounded-md flex items-center justify-center gap-5 transition-colors hover:bg-gray-200 duration-300"
    >
        <i class="lni text-3xl" :class="icon" aria-hidden="true"></i>

        <div class="text-sm">
            <span>{{ $trans.get('common.download_on_the') }}</span>
            <br>
            <span>{{ platform }}</span>
        </div>
    </a>
</template>